module.exports = __webpack_public_path__ + "static/media/cover2.5a8f7cd1.jpeg";